import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const deleteCategory = async (placeId, categoryId) => {
  if (!placeId || !categoryId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.delete({
    path: `${uri.api}/place/${placeId}/category/${categoryId}/delete`,
  });
};